import unbindSVG from '../../assets/icons/unbind.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const UnbindIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={unbindSVG} {...props} />;
};
